import React from "react";

import { styled } from '@mui/material/styles';

import { useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';

import {
  AppBar,
  Hidden,
  Toolbar,
  Button,
} from "@mui/material";
import InputIcon from "@mui/icons-material/Input";
import logo from "../../../assets/images/logo_wit_1280x500.png";
import { withTranslation } from "react-i18next";

const PREFIX = 'Minimal';

const classes = {
  root: `${PREFIX}-root`,
  flexGrow: `${PREFIX}-flexGrow`,
  tekenUitButton: `${PREFIX}-tekenUitButton`,
  tekenUitIcon: `${PREFIX}-tekenUitIcon`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    boxShadow: "none",
    paddingTop: "64px",
  },

  [`& .${classes.flexGrow}`]: {
    flexGrow: 1,
  },

  [`& .${classes.tekenUitButton}`]: {
    margin: "0 auto",
    display: "flex",
    color: "white",
  },

  [`& .${classes.tekenUitIcon}`]: {
    marginLeft: "5px",
    height: "20px",
  }
}));

const MinimalLayout = ({ t, ...props }) => {
  const { children } = props;
  const { route, signOut } = useAuthenticator((context) => [context.route, context.signOut]);
  const navigate = useNavigate();



  const tekenUit = () => {
    signOut();
    localStorage.removeItem("profiel");
    localStorage.removeItem("boerderye");
    navigate('/login');
  };

  return (
    <Root>
      <AppBar className="appBar">
        <Toolbar>
          <Hidden xlDown>
            <img alt="Logo" src={logo} className="pageLogo" />
          </Hidden>
          <div className={classes.flexGrow} />
          {route === 'authenticated' ?
            <Button className={classes.tekenUitButton} onClick={tekenUit}>
              {t("Teken uit")}
              <InputIcon className={classes.tekenUitIcon} />
            </Button> :
            null}
        </Toolbar>
      </AppBar>
      <div className={classes.root}>
        {children}
      </div>
    </Root>
  );
};

export default withTranslation(["translation"])(MinimalLayout);
